// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-JRB","question":"styles_question__19A8b","description":"styles_description__2wu5Z"};